export const calculateLikelihood = (occurrence) => {
  const threatLikelihood = occurrence;
  return threatLikelihood;
};
